var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatWeOffer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_595_10998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.5C24.4778 27.5 26.4112 26.9135 28.0557 25.8147C29.7002 24.7159 30.9819 23.1541 31.7388 21.3268C32.4957 19.4996 32.6937 17.4889 32.3079 15.5491C31.922 13.6093 30.9696 11.8275 29.5711 10.4289C28.1725 9.03041 26.3907 8.078 24.4509 7.69215C22.5111 7.3063 20.5004 7.50433 18.6732 8.26121C16.8459 9.01809 15.2841 10.2998 14.1853 11.9443C13.0865 13.5888 12.5 15.5222 12.5 17.5C12.5 20.1522 13.5536 22.6957 15.4289 24.5711C17.3043 26.4464 19.8478 27.5 22.5 27.5ZM42.5 32.5C43.9834 32.5 45.4334 32.0601 46.6668 31.236C47.9001 30.4119 48.8614 29.2406 49.4291 27.8701C49.9968 26.4997 50.1453 24.9917 49.8559 23.5368C49.5665 22.082 48.8522 20.7456 47.8033 19.6967C46.7544 18.6478 45.418 17.9335 43.9632 17.6441C42.5083 17.3547 41.0003 17.5033 39.6299 18.0709C38.2594 18.6386 37.0881 19.5999 36.264 20.8332C35.4399 22.0666 35 23.5166 35 25C35 26.9891 35.7902 28.8968 37.1967 30.3033C38.6032 31.7098 40.5109 32.5 42.5 32.5ZM52.5 50C53.163 50 53.7989 49.7366 54.2678 49.2678C54.7366 48.7989 55 48.1631 55 47.5C54.998 45.1635 54.3412 42.8743 53.104 40.8922C51.8669 38.9101 50.099 37.3144 48.0009 36.2862C45.9028 35.258 43.5585 34.8384 41.234 35.075C38.9095 35.3117 36.6978 36.1951 34.85 37.625C32.4013 35.1859 29.2851 33.5265 25.8946 32.8561C22.504 32.1856 18.9908 32.5342 15.7981 33.8578C12.6053 35.1815 9.87603 37.4208 7.95435 40.2936C6.03267 43.1663 5.00468 46.5438 5 50C5 50.6631 5.26339 51.2989 5.73223 51.7678C6.20107 52.2366 6.83696 52.5 7.5 52.5H37.5C38.163 52.5 38.7989 52.2366 39.2678 51.7678C39.7366 51.2989 40 50.6631 40 50",
    fill: "#273B8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_595_10998",
    x: 5,
    y: 7.5,
    width: 52,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_595_10998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_595_10998",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeOffer1);
export default __webpack_public_path__ + "static/media/whatWeOffer1.09e14493a782968a4d6763cfee407871.svg";
export { ForwardRef as ReactComponent };